import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: "#2f3640",
  textColor: "#f5f6fa",
  accentColor: "#4cd137",
  pointColor: "rgba(0, 0, 0, 0.4)",
  selectColor: "rgba(0, 0, 0, 0.8)",
};

export const lightTheme: DefaultTheme = {
  bgColor: "#f5f6fa",
  textColor: "#2f3640",
  accentColor: "#4cd137",
  pointColor: "rgba(220, 221, 225,0.4)",
  selectColor: "rgba(76, 209, 55,0.6)",
};
